import React from 'react';
import proptypes from 'prop-types';
import {
  arrayOf as arrayOfType,
  customType,
  params,
  namedFragment,
  shape,
  typename,
  bool as boolType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { HeroFlattenImageComponent } from './HeroFlattenImageComponent';

const { string, number, bool, shape: propShape } = proptypes;

const HeroFlattenImage = ({
  componentId = '',
  layoutRendererPrerenderedChildIndex = undefined,
  isB2C = false,
  proAnalyticsCampaign = undefined,
  proAnalyticsComponent = undefined,
  proCustomerSegment = undefined,
  livePreviewData = null,
  ssr = true,
}) => {
  const { data, loading, error } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass: 'HeroFlattenImage',
    },
    ssr,
    skip: !!livePreviewData,
  });

  const componentData = data?.component || livePreviewData;

  // If we have livePreviewData, render immediately, ignoring loading/error
  if ((!componentData || loading || error) && !livePreviewData) {
    return null;
  }

  const heroFlattenImageData = componentData.HeroFlattenImage || componentData;

  return (
    <HeroFlattenImageComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...heroFlattenImageData}
      layoutRendererPrerenderedChildIndex={layoutRendererPrerenderedChildIndex}
      isB2C={isB2C}
      proAnalyticsCampaign={proAnalyticsCampaign}
      proAnalyticsComponent={proAnalyticsComponent}
      proCustomerSegment={proCustomerSegment}
    />
  );
};

HeroFlattenImage.propTypes = {
  componentId: string,
  componentClass: string,
  layoutRendererPrerenderedChildIndex: number,
  isB2C: bool,
  proAnalyticsCampaign: string,
  proAnalyticsComponent: string,
  proCustomerSegment: string,
  livePreviewData: propShape(HeroFlattenImageComponent.propTypes),
  ssr: bool,
};

HeroFlattenImage.displayName = 'HeroFlattenImage';

// Do not touch
const DamMediaFragment = namedFragment({
  inline: false,
  fragmentType: 'DamMedia',
  fragmentAlias: 'DamMediaV3'
}).shape({
  damContentSelector: shape({
    assetData: arrayOfType(
      shape({
        selectedImageUrl: stringType()
      })
    )
  }),
  damDownloadedContent: shape({
    url: stringType()
  }),
  imageHotspot: shape({
    id: stringType(),
    title: stringType(),
    imageUrl: stringType(),
    hotspots: stringType(),
    hotspotActions: arrayOfType(shape({
      id: stringType(),
      url: stringType(),
      title: stringType(),
      drawer: shape({
        headline: stringType(),
      })
    }))
  }),
  __typename: typename('DamMedia')
});

HeroFlattenImage.dataModel = {
  component: params({
    id: stringType().isRequired(),
    componentClass: customType('ComponentClass').enum(['HeroFlattenImage']).isRequired()
  }).shape({
    HeroFlattenImage: namedFragment({
      inline: true,
      fragmentType: 'HeroFlattenImage'
    }).shape({
      id: stringType(),
      title: stringType(),
      previewImage: DamMediaFragment,
      mobilePreviewImage: DamMediaFragment,
      posterImage: DamMediaFragment,
      link: stringType(),
      altText: stringType(),
      componentName: stringType(),
      shouldLoopVideo: boolType(),
      __typename: typename('HeroFlattenImage')
    })
  })
};

export { HeroFlattenImage };